import { AppContext } from 'providers/AppContext';
import { useContext } from 'react';

type RiskqDescriptionProps = {
	isLastPage: boolean;
	prefix: string;
	testType: string;
};

export function RiskqDescription({ isLastPage, prefix, testType }: RiskqDescriptionProps) {
	const { t } = useContext(AppContext);
	const key = isLastPage ? `${testType}_derivatives_question` : `${prefix}_description_info`;
	const text = t(key, 'riskq');
	return text ? <p className="arionui mb-4">{text}</p> : null;
}
